import { type PostHog } from 'posthog-js/react';

class PosthogTracker {
  // eslint-disable-next-line no-restricted-syntax
  get posthog(): PostHog | undefined | null {
    if (typeof window === 'undefined') return undefined;
    return window.posthog as PostHog | undefined | null;
  }

  private capture(event: string, properties?: Record<string, any>) {
    this.posthog?.capture(event, properties);
  }

  get isAvailable() {
    // check if posthog is available if it has the capture method
    return !!this.posthog?.capture;
  }

  get isIdentified() {
    return this.posthog?._isIdentified();
  }

  identify(phoneNumber: string) {
    this.posthog?.identify(phoneNumber);
  }

  captureViewItemList() {
    this.capture('view_item_list');
  }

  capturePurchase({ price, specialityLabel }: { price: number; specialityLabel: string }) {
    this.capture('purchase', { currency: 'EUR', price, specialityLabel });
  }

  captureAddToCart() {
    this.capture('add_to_cart');
  }

  captureConfirmTimeSelection() {
    this.capture('confirm_time_selection');
  }

  captureWhatsappClick() {
    this.capture('click_card_whatsapp');
  }

  capturePhoneClick() {
    this.capture('click_card_telefono');
  }

  captureMobilePhoneClick() {
    this.capture('click_card_telefono_only');
  }
}

export const posthogTracker = new PosthogTracker();
